<template>
    <vx-table-row>
        <vx-table-row-title>
            <div class="flex flex-col items-start">
                <vx-badge color="slate" size="xs" class="font-mono" data-test="campaign-id">
                    {{ props.modelValue.campaign_id }}
                </vx-badge>
                <span class="text-xs font-normal text-slate-500" data-test="source">{{ sourceLabel }}</span>
            </div>
        </vx-table-row-title>

        <vx-table-row-item data-test="brand">
            <template v-slot:label> Brand: </template>
            <div v-if="props.modelValue.brand_id" class="flex flex-col min-w-0">
                <span class="text-xs font-mono">{{ props.modelValue.brand_id }}</span>
                <span class="text-sm font-bold line-clamp-2" :title="props.modelValue.brand_display_name ?? undefined">
                    {{ props.modelValue.brand_display_name || '—' }}
                    <span
                        v-if="props.modelValue.brand_vetting_score !== null"
                        class="text-xs font-normal text-slate-500"
                        data-test="brand-vetting-score"
                    >
                        (score {{ props.modelValue.brand_vetting_score }})
                    </span>
                </span>
            </div>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="usecase">
            <template v-slot:label> Use Case: </template>
            <span>{{ props.modelValue.usecase || '—' }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="status">
            <template v-slot:label> Status: </template>
            <span>{{ props.modelValue.status || '—' }}</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="phone-numbers-count">
            <template v-slot:label> Numbers: </template>
            {{ props.modelValue.phone_numbers_count }}
        </vx-table-row-item>

        <vx-table-row-item data-test="synced-at">
            <template v-slot:label> Synced: </template>
            <vx-popover hover :arrow="true" placement="top" :key="syncedAtKey">
                {{ fromNow(props.modelValue.synced_at) }}
                <template v-slot:content>
                    {{ shortDateTime(props.modelValue.synced_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { VxBadge, VxPopover, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import { computed } from 'vue';
import type { TcrCampaign } from '~/services/adminTenDlcClient.types';
import { fromNow, shortDateTime } from '~/utils/date';

const props = defineProps<{
    modelValue: TcrCampaign;
}>();

const syncedAtKey = useInterval(60000);

const sourceLabel = computed(() => (props.modelValue.source === 'twilio' ? 'via Twilio' : 'via TCR'));
</script>
